"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOAuth = void 0;
const tslib_1 = require("tslib");
const common_components_1 = require("@as-react/common-components");
const common_queries_1 = require("@as-react/common-queries");
const react_query_1 = require("@tanstack/react-query");
const useFeatureToggle_1 = require("./useFeatureToggle");
const react_1 = require("react");
const QueryClientUtil_1 = tslib_1.__importDefault(require("../util/QueryClientUtil"));
const common_utils_1 = require("@as-react/common-utils");
const common_types_1 = require("@as-react/common-types");
const AUTH_LOGIN_ENDPOINT = '/auth/login';
const useOAuth = ({ returnTo, flow } = {}) => {
    const { servicesEndpoint, defaultRequestParams, rootWithLanguageSuffix, oauth, canonicalUrl } = (0, common_components_1.useAemConfig)();
    const currentUrl = typeof window !== 'undefined' && window.location ? window.location.href : canonicalUrl;
    const currentPath = typeof window !== 'undefined' && window.location ? window.location.pathname : '';
    const redirectUri = new URL(`${rootWithLanguageSuffix}/auth.html`, currentUrl);
    const isNewAuth = (0, useFeatureToggle_1.useFeatureToggle)('use_new_auth_flow');
    const { getUserinfo, logout: logoutQuery } = (0, common_queries_1.authQueries)({ servicesEndpoint, defaultRequestParams });
    const { data: userInfo } = (0, react_query_1.useQuery)(getUserinfo({
        enabled: isNewAuth,
    }));
    const authUrl = (0, react_1.useMemo)(() => {
        const authUrl = new URL(`${AUTH_LOGIN_ENDPOINT}`, servicesEndpoint.startsWith('http') ? servicesEndpoint : currentUrl);
        const params = new URLSearchParams(authUrl.search);
        params.append('response_type', 'code');
        params.append('client_id', oauth.clientId);
        params.append('scope', 'openid');
        params.append('redirect_uri', redirectUri.toString());
        params.append('returnTo', returnTo || currentPath);
        if (flow) {
            params.append('flow', flow);
        }
        for (const [key, value] of Object.entries(defaultRequestParams)) {
            if (value !== undefined && value !== null) {
                params.append(key, value.toString());
            }
        }
        authUrl.search = params.toString();
        return authUrl.toString();
    }, [returnTo, flow]);
    const logout = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { id_token } = common_utils_1.localStorageUtil.getWithExpiry(common_types_1.AUTH_STORAGE_KEY);
        localStorage.removeItem(common_types_1.AUTH_STORAGE_KEY);
        try {
            yield QueryClientUtil_1.default.fetchQuery(logoutQuery({
                clientId: oauth.clientId,
                redirectUri: currentUrl,
                oidcToken: id_token,
            }, {
                staleTime: 0,
            }));
        }
        finally {
            window.location.reload();
        }
    });
    return {
        authUrl,
        loggedIn: !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.email),
        logout,
    };
};
exports.useOAuth = useOAuth;
